(function () {
    'use strict';

    angular.module('app').factory('UploadQueueService', function CostingService(WebApiService) {
        return {
            /**
             * Gets the initial page model including current queue items and most recent history items.
             * @returns UploadQueuePageModel
             */
            getUploadQueuePageModel: function () {
                return WebApiService.get('api/UploadQueue');
            },

            /**
             * Gets the initial page model including current queue items and most recent history items.
             * @returns UploadQueuePageModel
             */
            getUploadDetailsPageModel: function (request) {
                return WebApiService.get('api/UploadQueue/Details', request);
            },

            /**
             * Retrieves a list of items currently in the upload queue
             * @param { QueuedUploadFilter } filter
             * @returns a list of items { List<QueuedUploadItem> }
             */
            getQueuedUploads: function (filter) {
                return WebApiService.get('api/UploadQueue/Items', filter);
            },

            /**
             * Searches for completed, cancelled or failed upload queue items
             * @param { UploadQueueHistoryFilter } filter
             * @returns a paged list of items PagedResult<UploadQueueHistoryItem>
             */
            searchUploadQueueHistory: function (filter) {
                return WebApiService.get('api/UploadQueue/History', filter);
            },

            uploadResume: function (jobGuid, status) {
                return WebApiService.postJson('api/UploadQueue/Resume?jobGuid=' + jobGuid + '&currentStatus=' + status);
            },

            uploadCancel: function (jobGuid, status) {
                return WebApiService.postJson('api/UploadQueue/Cancel?jobGuid=' + jobGuid + '&currentStatus=' + status);
            }
        };
    });
})();
